import React from 'react'
import { IPOrganismosContext } from '../../features/ip-organismos'
import { IPOrganismosRouter } from './routers'

export const IPOrganismosPage = () => {
  return (
    <IPOrganismosContext>
      <IPOrganismosRouter />
    </IPOrganismosContext>
  )
}
